import { render, staticRenderFns } from "./PuckListItem.vue?vue&type=template&id=0eb818e8"
import script from "./PuckListItem.vue?vue&type=script&lang=js"
export * from "./PuckListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports